import { render, staticRenderFns } from "./accessible_panel_resizer.vue.js?vue&type=template&id=242776d0!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./accessible_panel_resizer.vue?vue&type=template&id=242776d0"
import script from "./accessible_panel_resizer.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./accessible_panel_resizer.vue?vue&type=script&lang=js"
export * from "./accessible_panel_resizer.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./accessible_panel_resizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('242776d0')) {
      api.createRecord('242776d0', component.options)
    } else {
      api.reload('242776d0', component.options)
    }
    module.hot.accept("./accessible_panel_resizer.vue.js?vue&type=template&id=242776d0!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./accessible_panel_resizer.vue?vue&type=template&id=242776d0", function () {
      api.rerender('242776d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/accessible_panel_resizer.vue"
export default component.exports